module.exports = __webpack_public_path__ + "img/history_btn.c7ee1f60.png";